<template>
  <a-card>
    <template slot="title">
      <a-icon v-if="issue.status === 'OPEN'" type="clock-circle" theme="twoTone" twoToneColor="#1890ff" style="margin-right: 6px"/>
      <a-icon v-else type="check-circle" theme="twoTone" twoToneColor="#52c41a" style="margin-right: 6px"/>
      {{ issue.title }}
    </template>
    <template slot="extra">
      <a-button v-if="issue.status === 'OPEN'" type="primary" size="small" icon="check" @click="openModal">Zamknij zgłoszenie</a-button>
      <a-popconfirm v-else key="reopen" title="Czy na pewno chcesz ponownie otworzyć to zgłoszenie?" ok-text="Tak" cancel-text="Nie"
                    @confirm="reopenIssue">
        <a-button type="dashed" size="small" icon="rollback">Otwórz ponownie</a-button>
      </a-popconfirm>
    </template>
    <template slot="actions" class="ant-card-actions">
            <span key="profile" @click="$router.push({ name: 'User', params: { uuid: issue.account.accountUuid } })">
              {{ issue.account.name + ' ' + issue.account.surname }}
            </span>
      <span key="location">
              {{ issue.dorm.name }} &bull; {{ issue.room }}
            </span>
      <span key="created">
              {{ new Date(issue.created) | moment("HH:mm:ss &bull; DD.MM.yyyy r.") }}
            </span>
    </template>
    {{ issue.description }}
    <span v-if="issue.result && issue.result !== ''">
            <a-divider/>
            <strong>Wynik:</strong>
            <vue-markdown
                :anchorAttributes="{ target: '_blank', rel: 'nofollow' }"
                :linkify="true"
                :xhtml-out="true"
                class="markdown-field"
            >
              {{ issue.result.trim() }}
            </vue-markdown>
          </span>
    <a-modal v-model="closeIssueModalVisible"
             title="Kończenie zgłoszenia"
             @ok="resolveIssue"
             @cancel="closeModal"
             okText="Zamknij zgłoszenie"
             cancelText="Nie zamykaj"
    >
      <a-form :form="form">
        <a-form-item label="Rezultat" :label-col="{span: 6}" :wrapper-col="{span: 14}">
          <a-textarea v-model="form.result" placeholder="Powód zakończenia zgłoszenia" :autosize="{minRows: 3, maxRows: 5}" :disabled="closeIssueLoading"/>
          <a-tag color="blue" @click="form.result = 'Problem został rozwiązany.'">
            Problem rozwiązany
          </a-tag>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import httpClient from "@/utils/httpClient";
import moment from "moment";
import VueMarkdown from "vue-markdown";

export default {
  name: 'SingleIssue',
  components: {VueMarkdown},
  computed: {
    moment() {
      return moment
    }
  },
  data() {
    return {
      form: {
        result: ""
      },
      closeIssueModalVisible: false,
      closeIssueLoading: false,
    }
  },
  props: {
    issue: {}
  },
  methods: {
    resolveIssue() {
      httpClient
          .post(`/admin/issues/${this.issue.issueId}/resolve`, this.form)
          .then(() => {
            this.$message.success("Zgłoszenie zostało zakończone")
            this.form.result = "";
            this.closeIssueModalVisible = false;
            this.$emit("changed")
          }).catch((error) => {
        if (error.response.status !== 401) {
          this.$message.error("Wystąpił błąd z zakończeniem zgłoszenia")
        }
      });
    },

    reopenIssue() {
      httpClient
          .post(`/admin/issues/${this.issue.issueId}/reopen`, {result: "Zgłoszenie ponownie otwarte"})
          .then(() => {
            this.$message.success("Zgłoszenie zostało ponownie otwarte")
            this.$emit("changed")
          }).catch((error) => {
        if (error.response.status !== 401) {
          this.$message.error("Wystąpił błąd z ponownym otwarciem zgłoszenia")
        }
      });
    },

    openModal() {
      this.closeIssueModalVisible = true
    },

    closeModal() {
      this.closeIssueModalVisible = false
      this.form.result = ""
    },
  }
}
</script>
